import React, { useState } from 'react';
import { BookOpenIcon, Bars3BottomRightIcon, XMarkIcon } from '@heroicons/react/24/solid'
import logo from "../asset/logo.png"
import ReactGA from 'react-ga';
import { useEffect } from 'react';



const Navbar = () => {
    let Links =[
        {name:"Home",link:"#"},
        {name:"About",link:"#about"},
        {name:"Product",link:"#Product"},
        {name:"Team",link:"#team"},
   
      ];
      let [open, setOpen] =useState(false);

      const handleWhatsAppClick = () => {
        // Ganti dengan link API WhatsApp yang sesuai
        const whatsappLink = 'https://api.whatsapp.com/send?phone=6281212851807';
        
        // Buka link WhatsApp
        window.open(whatsappLink, '_blank');
      };
    
      useEffect(() => {
        ReactGA.pageview(window.location.pathname);
      
      }, {} );

    return (
        
        <div className='shadow-md w-full fixed top-0 left-0 z-50 '>
           <div className='md:flex items-center justify-between bg-white  py-3 md:px-10 px-7'>
            {/* logo section */}
            <div className='font-bold text-lg cursor-pointer flex items-center gap-1'>
               <img className='h-12 w-12' src={logo} alt="" />
                {/* <span>Inscribe</span> */}
            </div>
            {/* Menu icon */}
            <div onClick={()=>setOpen(!open)} className='absolute right-8 top-6 cursor-pointer md:hidden w-7 h-7'>
                {
                    open ? <XMarkIcon/> : <Bars3BottomRightIcon />
                }
            </div>
            {/* linke items */}
            <ul className={`md:flex md:items-center md:pb-0 pb-12 absolute md:static bg-white md:z-auto z-[-1] left-0 w-full md:w-auto md:pl-0 pl-9 transition-all duration-500 ease-in ${open ? 'top-12' : 'top-[-490px]'}`}>
                {
                    Links.map((link) => (
                    <li className='md:ml-8 md:my-0 my-7 text-lg font-semibold'>
                        <a href={link.link} className='text-gray-800 hover:text-blue-400 duration-500'>{link.name}</a>
                    </li>))
                }
                <button className='btn bg-green-600 text-white text md:ml-8 font-semibold px-3 py-1 hover:text-xl rounded duration-500 md:static'  onClick={handleWhatsAppClick}>Contact us</button>
            </ul>
            {/* button */}
           </div>
        </div>
    );
};

export default Navbar;